/*
  cbx-attribution.js — kampanya kaynağını sepet özelliğine yazar.

  URL'deki utm_* ve tıklama kimliklerini (gclid, fbclid vb.) okur, ilk ve son temas
  olarak saklar, sepet özelliği üzerinden sipariş kaydına taşır.

  - `__` önekli özellikler müşteriye gösterilmez.
  - İlk temas korunur, son temas güncellenir; iç gezinme son temması ezmez.
  - /cart/update.js yalnız değer değiştiğinde çağrılır.
*/
(function () {
  'use strict';

  var DEPO = 'cbx_atif_v1';
  var OMUR_GUN = 90;
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var TIK = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid', 'srsltid', 'twclid'];
  var KAMPANYA_ID = ['gad_campaignid', 'gad_source'];

  function guvenliDepo() {
    try {
      var t = '__cbx_t';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return window.localStorage;
    } catch (e) {
      return null;
    }
  }

  function oku(depo) {
    if (!depo) return null;
    try {
      var ham = depo.getItem(DEPO);
      if (!ham) return null;
      var v = JSON.parse(ham);
      if (!v || !v.ilk) return null;
      // ömrü dolmuşsa sıfırla
      if (v.ilk.ts && (Date.now() - v.ilk.ts) > OMUR_GUN * 864e5) return null;
      return v;
    } catch (e) {
      return null;
    }
  }

  function yaz(depo, v) {
    if (!depo) return;
    try { depo.setItem(DEPO, JSON.stringify(v)); } catch (e) { /* kota dolu — sessiz geç */ }
  }

  /* Mevcut URL'den bir "temas" nesnesi çıkarır. Kaynak sinyali yoksa null döner. */
  function temasCikar() {
    var p;
    try { p = new URL(window.location.href).searchParams; } catch (e) { return null; }

    var t = { ts: Date.now() };
    var sinyalVar = false;

    UTM.forEach(function (k) {
      var v = p.get(k);
      if (v) { t[k.replace('utm_', '')] = v.slice(0, 120); sinyalVar = true; }
    });

    TIK.forEach(function (k) {
      var v = p.get(k);
      if (v) { t[k] = v.slice(0, 200); sinyalVar = true; }
    });

    KAMPANYA_ID.forEach(function (k) {
      var v = p.get(k);
      if (v) { t[k] = v.slice(0, 60); sinyalVar = true; }
    });

    // Tıklama kimliği/UTM yoksa DIŞ yönlendireni kaynak say
    if (!sinyalVar) {
      var ref = document.referrer || '';
      if (ref) {
        var rh = '';
        try { rh = new URL(ref).host; } catch (e) { rh = ''; }
        if (rh && rh !== window.location.host) {
          t.ref = rh.slice(0, 120);
          sinyalVar = true;
        }
      }
    }

    if (!sinyalVar) return null;

    try { t.lp = window.location.pathname.slice(0, 160); } catch (e) { /* yoksay */ }
    return t;
  }

  /* Sepet özelliği için kompakt string — uzunluk sınırına takılmamak adına */
  function duzlestir(t) {
    if (!t) return '';
    var parca = [];
    ['source', 'medium', 'campaign', 'content', 'term', 'id'].forEach(function (k) {
      if (t[k]) parca.push(k + '=' + t[k]);
    });
    TIK.concat(KAMPANYA_ID).forEach(function (k) {
      if (t[k]) parca.push(k + '=' + t[k]);
    });
    if (t.ref) parca.push('ref=' + t.ref);
    if (t.lp) parca.push('lp=' + t.lp);
    if (t.ts) parca.push('ts=' + new Date(t.ts).toISOString().slice(0, 19) + 'Z');
    return parca.join('|').slice(0, 900);
  }

  function sepeteYaz(ilkStr, sonStr) {
    var govde = { attributes: {} };
    govde.attributes['__atif_ilk'] = ilkStr;
    govde.attributes['__atif_son'] = sonStr;

    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(govde)
    });
  }

  function calistir() {
    var depo = guvenliDepo();
    var kayit = oku(depo) || {};
    var yeni = temasCikar();
    var degisti = false;

    if (yeni) {
      if (!kayit.ilk) { kayit.ilk = yeni; degisti = true; }
      // son temas: yalnız gerçek bir kaynak sinyali geldiyse güncelle
      var oncekiSon = kayit.son ? duzlestir(kayit.son) : '';
      if (duzlestir(yeni) !== oncekiSon) { kayit.son = yeni; degisti = true; }
    }

    if (!kayit.ilk) return; // hiç kaynak sinyali görülmedi — yazacak bir şey yok

    var ilkStr = duzlestir(kayit.ilk);
    var sonStr = duzlestir(kayit.son || kayit.ilk);

    // Sepete zaten aynı değer yazıldıysa tekrar istek atma
    if (kayit.yazilan === ilkStr + '~' + sonStr && !degisti) return;

    sepeteYaz(ilkStr, sonStr).then(function (r) {
      if (r && r.ok) {
        kayit.yazilan = ilkStr + '~' + sonStr;
        yaz(depo, kayit);
      }
    }).catch(function () { /* ağ hatası — bir sonraki sayfada tekrar denenir */ });

    yaz(depo, kayit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calistir, { once: true });
  } else {
    calistir();
  }
})();
